define([
	"csi/access/_base",
	"csi/access/access",
	"csi/access/full",
	"csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

	var productSpecLibraryAdminRoles = ['Product Specification Library Administrator'];

	var themeAdminRoles = ['Theme Administrator', 'Theme Editor'];
	var themeViewRoles = themeAdminRoles.concat(['Theme Viewer']);

	csiAccess.addViewRoles({
		"_CS_ApparelViews":{
			"ProductStructure": {
				"NewProductStructure":access( full(productSpecLibraryAdminRoles)),
				"Copy":access( full(productSpecLibraryAdminRoles)),
				"Delete":access(full(productSpecLibraryAdminRoles))
			}
		},
		"Theme": {
			"ReportColors":{
				"SyncToTheme":access(full(themeViewRoles))
			},
			"ReportPlacements":{
				"CreateThemePlacements":access(full(themeAdminRoles))
			}
		},
		"Season": {
			"SeasonReportColors":{
				"SyncToTheme":access(full(themeViewRoles))
			},
			"SeasonReportPlacements":{
				"CreateThemePlacements":access(full(themeAdminRoles))
			}
		}
	});
});